import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c105a89"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "joy-header" }
const _hoisted_2 = { class: "_left" }
const _hoisted_3 = { class: "_right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "joy-header-title",
  class: "_title-container"
}, null, -1))
const _hoisted_5 = { class: "_links-container" }
const _hoisted_6 = { class: "help" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "|", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JoystickTextLogo = _resolveComponent("JoystickTextLogo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'home' } }, {
        default: _withCtx(() => [
          _createVNode(_component_JoystickTextLogo)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.clientAppVersion), 1),
        _hoisted_7,
        _createElementVNode("a", {
          href: "",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.logout()), ["prevent"]))
        }, "Logout")
      ])
    ])
  ]))
}